var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MembershipEditor',_vm._g({ref:"editor",attrs:{"add-member-dialog-name":"AddProjectMemberDialog","modal-sticky":true,"default-binding-handler":_vm.defaultBindingHandler,"type":_vm.NORMAN.PROJECT_ROLE_TEMPLATE_BINDING,"mode":_vm.mode,"parent-key":"projectId","parent-id":_vm.parentId}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }